"use client";

import { usePortalContext } from "@cloai/uikit";
import { ChangeEvent, useState } from "react";
import { useCookies } from "react-cookie";

import { sendFeedback } from "@/app/_actions/sendFeedback";
import {
  useGTMContext,
  useProfileContext,
  useUndressContext,
} from "@/providers";

import { COOKIES, COOKIES_TIMES } from ".constants/cookies";
import { GE } from ".constants/gtmEvents";

export const useFeedbackPortal = () => {
  const { closePortal } = usePortalContext();
  const profile = useProfileContext();
  const { clickUndress } = useUndressContext();
  const [, setCookies] = useCookies([COOKIES.HIDE_FEEDBACK_MODAL]);
  const { sendGTM } = useGTMContext();

  const [feedback, setFeedback] = useState("");
  const [loading, setLoading] = useState(false);

  const onClose = () => {
    closePortal();
    setFeedback("");
    setCookies(COOKIES.HIDE_FEEDBACK_MODAL, 1, {
      maxAge: COOKIES_TIMES.DAY_1,
    });
  };

  const onFeedBackChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setFeedback(e.target.value);
  };

  const onSendFeedBack = async () => {
    try {
      setLoading(true);
      sendGTM({ event: GE.CLICK_SEND_FEEDBACK_AFTER_RATING });
      await sendFeedback({
        feedback,
        userId: profile?.id || "NULL",
        genId: clickUndress?.id || "NULL",
        balance: profile?.coins || 0,
        rating: clickUndress?.rating || 0,
      });
    } catch (err) {
      console.error("SEND FEEDBACK ERROR BY NOTION: ", err);
      sendGTM({ event: GE.USER_SENT_FEEDBACK_AFTER_RATING_ERR });
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return {
    onClose,
    onFeedBackChange,
    onSendFeedBack,
    feedback,
    loading,
  };
};
